import { render, staticRenderFns } from "./userMenu.vue?vue&type=template&id=22f9ffa6&scoped=true"
import script from "./userMenu.vue?vue&type=script&lang=js"
export * from "./userMenu.vue?vue&type=script&lang=js"
import style0 from "./userMenu.vue?vue&type=style&index=0&id=22f9ffa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f9ffa6",
  null
  
)

export default component.exports